import { attr, customElement, FASTElement, observable } from '@microsoft/fast-element';
import { IndividualProjectVppasGridTemplate as template } from './individual-projects-vppas-grid.template';
import { IndividualProjectVppasGridStyles as styles } from './individual-projects-vppas-grid.styles';
import { ZeroGridPro as zeroAgGrid } from '@genesislcap/foundation-zero-grid-pro';
import { logger, Message, SocketSubscription } from '@genesislcap/foundation-comms';
import { IVppaService } from '../../../../services/vppa.service';
import { updateArray } from '../../../../utils/dataserver';
import { IIndividualProjectPageService } from '../../../../services/individual-project-page.service';
import { IEnumService } from '../../../../services/enum.service';
import { PRODUCT_TYPE } from '../../../../utils';

import { IVppa } from '../../../../types';
import { IUserService } from '../../../../services/user.service';
import { ICompanyService } from '../../../../services/company.service';

const name = 'individual-projects-vppas-grid';
@customElement({
  name,
  template,
  styles,
})
export class IndividualProjectVppasGrid extends FASTElement {
  @observable vppaGrid: zeroAgGrid;
  @observable vppaSubscription: SocketSubscription;
  @observable vppaList: IVppa[];
  @IVppaService vppaService: IVppaService;
  @ICompanyService companyService: ICompanyService;
  @IIndividualProjectPageService individualProjectPageService: IIndividualProjectPageService;
  @IEnumService enumService: IEnumService;
  @IUserService userService: IUserService;
  @attr productType: PRODUCT_TYPE = PRODUCT_TYPE.VIRTUAL_PPA;
  @attr gridProductType: PRODUCT_TYPE;
  @attr @observable vppa: any;
  // public vppaCriteria : string;
  @observable vppaId: string;

  private productTypeMap = new Map<PRODUCT_TYPE, string>([
    [PRODUCT_TYPE.VIRTUAL_PPA, 'Vppas'],
    [PRODUCT_TYPE.PHYSICAL_PPA, 'Ppas'],
    [PRODUCT_TYPE.RECS, 'Recs'],
  ]);

  connectedCallback() {
    super.connectedCallback();

    const gridOptions = {
      onRowDoubleClicked: (row) => this.vppaService.openVppaDetailModal(row.data?.VPPA_ID),
      animateRows: true,
      onRowSelected: (params) => this.rowSelected(params),
      scrollbarWidth: 10,
      defaultColDef: {
        resizable: true,
        wrapHeaderText: true,
        autoHeaderHeight: true,
      },
    };

    this.vppaGrid.gridOptions = gridOptions;

    this.vppaId = this.individualProjectPageService.vppaId;

    this.productType = this.companyService.isNonSefParticipantAgreement()
      ? PRODUCT_TYPE.RECS
      : PRODUCT_TYPE.VIRTUAL_PPA;
  }

  public rowSelected(event: any) {
    if (event && event.node && event.node.selected) {
      this.vppaId = event.data.VPPA_ID;
      this.$emit('selectVppa', event.data);
    }
  }

  setProjectName(projectId) {
    let resultList = [];
    this.vppaList = [];
    const vppaCriteria = `(PROJECT_ID == '${projectId}' && PRODUCT_TYPE == '${this.gridProductType}' && VPPA_STATUS != 'EXECUTED' && VPPA_STATUS != 'DELETED')`;
    this.vppaSubscription?.unsubscribe();
    this.vppaSubscription = this.vppaService.getAllVppas(vppaCriteria).subscribe({
      next: (streamMessage: Message) => {
        resultList = streamMessage.ROW ?? null;
        let isEmptyBeforeUpdate = false;
        if(this.vppaList.length == 0) {
          isEmptyBeforeUpdate = true;
        }
        if (resultList) {
          this.vppaList = updateArray(resultList, this.vppaList);
          this.vppaGrid.gridApi.setRowData(this.vppaList);
        } else {
          this.vppaList = [];
          this.vppaGrid.gridApi.setRowData(this.vppaList);
        }
        if (this.vppaList.length == 0 || isEmptyBeforeUpdate) {
          this.productTypeChanged();
        }
      },
      error: (error: any) => {
        this.vppaList = [];
        if (this.gridProductType === this.productType) {
          this.$emit('selectVppa', null);
        }
        logger.error(error);
      },
    });
    this.vppaGrid.columnApi.setColumnVisible(
      'SETTLEMENT_POINT',
      this.productType !== PRODUCT_TYPE.RECS
    );
    this.updateGridCsv();
  }

  public checkGridStatus() {
    const pathArray = window.location.pathname.split('/');
    const projectId = pathArray[pathArray.length - 1];
    if (this.productType) {
      this.setProjectName(projectId);
    }
  }

  public onGridReady() {
    this.checkGridStatus();
  }
  public productTypeChanged() {
    if (this.vppaGrid?.columnApi) {
      if (this.gridProductType === this.productType) {
        if(this.vppaList.length > 0) {
          this.vppaGrid.gridApi.getDisplayedRowAtIndex(0)?.setSelected(true);
          this.$emit('selectVppa',this.vppaList[0])
        } else {
          this.$emit('selectVppa',null)
        }
      }
    }
  }

  public downloadGridCsv() {
    const csvParams = {
      fileName: this.productTypeMap.get(this.productType),
    };
    this.vppaGrid.gridApi.exportDataAsCsv(csvParams);
  }
  public updateGridCsv() {
    this.vppaGrid.gridApi.getDataAsCsv();
  }
}
